import Vue from 'vue'

// 获取虚拟库存列表
export function getList(params) {
  return Vue.prototype.$axios.get('/a1/virtualStock', { params })
}

// 获取虚拟库存详情
export function getById(id) {
  return Vue.prototype.$axios.get(`/a1/virtualStock/${id}`)
}

// 创建虚拟库存
export function create(data) {
  return Vue.prototype.$axios.post('/a1/virtualStock', data)
}

// 更新虚拟库存
export function update(id, data) {
  return Vue.prototype.$axios.put(`/a1/virtualStock/${id}`, data)
}

// 删除虚拟库存
export function remove(id) {
  return Vue.prototype.$axios.delete(`/a1/virtualStock/${id}`)
}

// 获取指定分类的虚拟库存
export function getVirtualStockByType4(type4) {
  return Vue.prototype.$axios.get(`/a1/virtualStock/type4/${type4}`)
}

// 计算有效库存
export function getEffectiveStock(data) {
  return Vue.prototype.$axios.post('/a1/virtualStock/effective', data)
}
